var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    staticClass: "s-btn s-btn-secondary s-btn-sm s-w-auto",
    attrs: {
      "type": "button",
      "disabled": _vm.waiting || !_vm.mobildNumberIsValid
    },
    on: {
      "click": _vm.sendVerifyCode
    }
  }, [_vm.timer ? [_vm._v(_vm._s(_vm.counter) + " 秒")] : [_vm._t("default", function () {
    return [_vm._v("發送驗證碼")];
  })]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }